import styled from "@emotion/styled";
import { Color } from "../../../../Theme";
var StyledButton = /*#__PURE__*/ styled("button", {
    target: "e1kp21ke0"
})("position:relative;margin:1.25rem 0 0.625rem;padding:0.9375rem 1.375rem;border:0;background-color:", Color.primary, ";color:", Color.natural0, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;width:100%;cursor:pointer;&:hover{background-color:", Color.primary70, ";}");
export { StyledButton };
